import React from 'react';
import { Typography } from 'antd';
import { Properties } from 'csstype';
import styled from 'styled-components';

const TitleDefault = styled(Typography.Title)`
  font-family: 'CirceBold';
  font-weight: 800;
`;

export interface TitleProps {
  level?: 4 | 1 | 2 | 3 | undefined;
  style?: Properties;
}

const Title: React.FC<TitleProps> = ({ children, level, style }) => (
  <TitleDefault style={style} level={level}>
    {children}
  </TitleDefault>
);

export default Title;
